import Vue from 'vue'

import withRender from './summary-dim-select.html'
import './summary-dim.scss'
import './summary-dim-select.scss'

export default withRender(Vue.extend({
  props: {
    dim: Object, // SummaryDimension
    dimFiltersOn: Boolean,
    headingLevel: { type: Number, default: 3 }
  },
  computed: {
    values() {
      return this.dim && this.dim.values ? this.dim.values.filter(d => d.count > 0) : []
    },
    valuesAsText() {
      return this.values.map(v => `${v.label} (${v.count})`).join(', ')
    }
  },
  methods: {
    filterBy(dimVal) {
      this.$emit('setFilter', 'dm', this.dim.dimensionDefinitionId.toString(), dimVal.id, this.dim)
    }
  }
}))
